import { useState, useMemo } from "react";

const baseDaTe = "01/01/1970";

const statusOrder = {
  ready: 1,
  pending: 2,
  draft: 3,
};

const sortDate = (date) => new Date(date !== "-" ? date : baseDaTe).getTime();

const sortTable = ({ aSort, bSort }, { aName, bName }, direction) => {
  if (aSort < bSort) return direction === "ascending" ? -1 : 1;
  else if (aSort > bSort) return direction === "ascending" ? 1 : -1;

  if (aName > bName) return 1;
  else if (aName < bName) return -1;

  return 0;
};

const useSortableTable = (items = [], config) => {
  const [sortConfig, setSortConfig] = useState(config || null);

  const sortedItems = useMemo(() => {
    const sortableItems = [...items];

    if (sortConfig) {
      sortableItems.sort((a, b) => {
        let aSort = a[sortConfig.key];
        let bSort = b[sortConfig.key];
        let aName = "";
        let bName = "";

        if (sortConfig.key === "date") {
          aSort = sortDate(a.rawDateTime);
          bSort = sortDate(b.rawDateTime);
        } else if (sortConfig.key === "status") {
          aSort = statusOrder[a.status.type];
          bSort = statusOrder[b.status.type];
        } else {
          aSort = aSort?.toLowerCase();
          bSort = bSort?.toLowerCase();
        }

        if (sortConfig.key !== "name") {
          aName = a["name"]?.toLowerCase();
          bName = b["name"]?.toLowerCase();
        }

        return sortTable(
          { aSort, bSort },
          { aName, bName },
          sortConfig.direction
        );
      });
    }

    return sortableItems;
  }, [items, sortConfig]);

  const requestSort = (key) => {
    let direction = "descending";
    if (
      sortConfig &&
      sortConfig.key === key &&
      sortConfig.direction === "descending"
    ) {
      direction = "ascending";
    }

    setSortConfig({ key, direction });
  };

  return { items: sortedItems, requestSort, sortConfig };
};

export default useSortableTable;
